"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2281],{

/***/ 62281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ IframeDynamicWidthIframeComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
;// CONCATENATED MODULE: ./segments/desktop/core-components/iframe/default-props.js
/* harmony default export */ var default_props = ({
    src: "https://monday.com/test/inside-iframe",
    height: "630px",
    borderWidth: "0px",
    borderColor: "transparent",
    hideScrolling: false
});

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/iframe/iframe.scss.js

var StyledIframeComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tvl7oh0"
})("width:100%;display:flex;.iframe-core-component{width:100%;}");

// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
;// CONCATENATED MODULE: ./segments/desktop/core-components/iframe/iframe-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}








var SRC = "src";
var IframeComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(IframeComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(IframeComponent);
    function IframeComponent(props) {
        (0,_class_call_check/* default */.Z)(this, IframeComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "iframeLoaded", function() {
            _this.trackIframeEvent(bigbrain_event_types.IFRAME_LOADED);
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "iframeLoadingError", function() {
            _this.trackIframeEvent(bigbrain_event_types.IFRAME_LOAD_ERROR);
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "buildIframeParams", function() {
            var _props = _this.props, src = _props.src, hideScrolling = _props.hideScrolling;
            var decodedSrc = _this.state.decodedSrc;
            return {
                src: src || decodedSrc,
                scrolling: hideScrolling ? "no" : "auto",
                onLoad: _this.iframeLoaded,
                onError: _this.iframeLoadingError,
                style: _this.buildStyle()
            };
        });
        _this.state = {
            decodedSrc: null
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(IframeComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _window;
                var decodedSrc = (0,url.getDecodedParamFromQuery)((_window = window) === null || _window === void 0 ? void 0 : _window.location, SRC);
                this.setState({
                    decodedSrc: decodedSrc
                });
                this.trackIframeEvent(bigbrain_event_types.IFRAME_COMPONENT_RENDERED);
            }
        },
        {
            key: "trackIframeEvent",
            value: function trackIframeEvent(kind) {
                var _props = this.props, src = _props.src, router = _props.router;
                BigBrain("track", "homepage_iframe_tracking", {
                    kind: kind,
                    placement: router.asPath,
                    info1: src
                });
            }
        },
        {
            key: "buildStyle",
            value: function buildStyle() {
                var _props = this.props, height = _props.height, borderColor = _props.borderColor, borderWidth = _props.borderWidth;
                var borderHexColor = colors/* default */.Z[borderColor];
                return {
                    height: height,
                    border: "".concat(borderWidth, " ").concat(borderHexColor, " solid")
                };
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIframeComponent, {
                    className: "iframe-core-component-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", _object_spread({
                        className: "iframe-core-component"
                    }, this.buildIframeParams()))
                });
            }
        }
    ]);
    return IframeComponent;
}(react.PureComponent);
/* harmony default export */ var iframe_component = ((0,router.withRouter)(IframeComponent));
IframeComponent.defaultProps = default_props;

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/iframe-dynamic-width-iframe/iframe-dynamic-width-iframe-component.scss.js

var StyledIframeDynamicWidthIframeComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1vvfiac0"
})("margin:auto;display:flex;justify-content:center;");

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/iframe-dynamic-width-iframe/iframe-dynamic-width-iframe-component.js




function iframe_dynamic_width_iframe_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function iframe_dynamic_width_iframe_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            iframe_dynamic_width_iframe_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var IframeDynamicWidthIframeComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(IframeDynamicWidthIframeComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(IframeDynamicWidthIframeComponent);
    function IframeDynamicWidthIframeComponent() {
        (0,_class_call_check/* default */.Z)(this, IframeDynamicWidthIframeComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(IframeDynamicWidthIframeComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, width = _props.width, maxWidth = _props.maxWidth;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIframeDynamicWidthIframeComponent, {
                    className: "iframe-dynamic-width-iframe-component",
                    style: {
                        width: width,
                        maxWidth: maxWidth
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(iframe_component, iframe_dynamic_width_iframe_component_object_spread({}, this.props))
                });
            }
        }
    ]);
    return IframeDynamicWidthIframeComponent;
}(react.PureComponent);

IframeDynamicWidthIframeComponent.defaultProps = _object_spread_props(iframe_dynamic_width_iframe_component_object_spread({
    width: "100%"
}, default_props), {
    maxWidth: "".concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px")
});


/***/ })

}]);